import {IconButton} from "@mui/material";
import Settings from "@mui/icons-material/Settings";
import {useState} from "react";
import {BoardSettings} from "./BoardSettings";

export function BoardSettingsButton(props: {}) {
    const [show, setShow] = useState(false)

    return (
        <>
            <IconButton size="small" onClick={() => setShow(true)}>
                <Settings />
            </IconButton>

            {show && <BoardSettings onClose={() => setShow(false)} />}
        </>
    )

}